<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !folder_id ? "Add" : "Edit" }} {{ !is_training_doc ? "Folder" : "Document" }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<app-account-docs-edit *ngIf="!folder_id && is_training_doc" [folder]="folder" [show_document_types_list_for]="show_document_types_list_for" [show_document_visibility]="show_document_visibility" [permissions]="permissions"></app-account-docs-edit>
<app-template-docs-edit *ngIf="!folder_id && !is_training_doc" [folder]="folder" [show_document_types_list_for]="show_document_types_list_for" [show_document_visibility]="show_document_visibility" [permissions]="permissions"></app-template-docs-edit>

<mat-tab-group *ngIf="folder_id">
  <mat-tab label="Overview">
    <app-account-docs-edit *ngIf="is_training_doc" [folder]="folder" [show_document_types_list_for]="show_document_types_list_for" [show_document_visibility]="show_document_visibility" [permissions]="permissions"></app-account-docs-edit>
    <app-template-docs-edit *ngIf="!is_training_doc" [folder]="folder" [show_document_types_list_for]="show_document_types_list_for" [show_document_visibility]="show_document_visibility" [permissions]="permissions"></app-template-docs-edit>
  </mat-tab>
  <mat-tab label="Links">
    <app-account-docs-links [folderId]="folder_id" [folder]="folder" [permissions]="permissions"></app-account-docs-links>
  </mat-tab>
</mat-tab-group>
